import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/**
 * Shown whenever the device has no connection. Its job is to make "offline" a designed state rather
 * than a broken one — the screens below keep rendering their cached data.
 */
export function OfflineBanner() {
	const online = useOnlineStatus();
	if (online) return null;

	return (
		<div className="sticky top-0 z-50 flex items-center justify-center gap-2 bg-amber-500/15 text-amber-700 dark:text-amber-300 text-xs font-medium py-1.5 pt-[calc(0.375rem+env(safe-area-inset-top))]">
			<WifiOff className="size-3.5" />
			Offline — showing your saved data
		</div>
	);
}
